import {
  FetchAutocomplete,
  FetchAutocompleteChangeReason,
} from '@australiangreens/ag-internal-components';
import { AccordionField } from '@components/DrawerAccordion';
import { Search } from '@mui/icons-material';
import { Checkbox, FormControlLabel, Tooltip } from '@mui/material';
import { GeometryRecord } from '@/apis/geometries';
import { MANUAL_PLACEMENT_TOOLTIP } from '@/constants/filterCriteria/location';
import { useLookupGeometries } from '@/criteriaLookups';
import { LocationOperator } from '@/types/shared';

type LocationProps = {
  onChange: (
    newValue: GeometryRecord[],
    reason: FetchAutocompleteChangeReason,
    event: React.SyntheticEvent<Element, Event>
  ) => void;
  value: GeometryRecord[];
  operator: LocationOperator;
  onOperatorChange: (operator: LocationOperator) => void;
};

const Location = ({
  value = [] as GeometryRecord[],
  onChange,
  operator,
  onOperatorChange,
}: LocationProps) => {
  const lookupGeometries = useLookupGeometries();

  return (
    <AccordionField>
      <FetchAutocomplete
        lookup={lookupGeometries}
        minLength={3}
        label="Add a location"
        value={value}
        onChange={(newValue, reason, event) => {
          if (newValue.length === 0) {
            onOperatorChange('lives in');
          }
          onChange(newValue, reason, event);
        }}
        data-testid="Add a location"
        loadingText="Looking for locations..."
        noOptionsText="No locations found"
        popupIcon={<Search />}
        disableIconFlip
      />

      <Tooltip title={MANUAL_PLACEMENT_TOOLTIP}>
        <FormControlLabel
          disabled={value.length === 0}
          control={
            <Checkbox
              value={operator === 'lives or placement in'}
              checked={operator === 'lives or placement in'}
              onChange={(_, newChecked) => {
                if (newChecked) {
                  onOperatorChange('lives or placement in');
                } else onOperatorChange('lives in');
              }}
            />
          }
          label="Include people with manual placements"
        />
      </Tooltip>
    </AccordionField>
  );
};

export default Location;
